<template>
  <div>
    <b-modal
      ref="openModal"
      :title="'Card de origem #' + cardId"
      size="md"
      scrollable
    >
      <b-form-group label="Status" label-for="input-documento">
        <b-form-input type="text" v-model="processFilled.stageName" disabled />
      </b-form-group>

      <div v-for="value in processFilled.values" :key="value.id">
        <b-form-group :label="value.fieldName" label-for="input-documento">
          <b-form-input type="text" v-model="value.value" disabled />
        </b-form-group>
      </div>

      <template #modal-footer="{ ok }">
        <div class="right">
          <b-button variant="green" @click="ok()"> Fechar </b-button>
        </div>
      </template>

      <!-- <pre class="language-json"><code>{{ processFilled  }}</code></pre> -->
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "FilledModal",
  data() {
    return {
      processFilled: {},
      cardId: 0,
    };
  },
  methods: {
    openModal(id) {
      this.getFilled(id);
      this.cardId = id;
      this.$refs.openModal.show();
    },
    getFilled(id) {
      this.$apiWorkflow
        .get("/processFilled/getFilled/" + id)
        .then((response) => {
          this.processFilled = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>